var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.center)?_c('span',[_c('i',{class:['fad fa-spinner-third fa-spin', _vm.adClass]})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }